import { ODataSelect } from "@iconics/core";
import { SecurityProviderId, SecurityProviderId_Native } from "../../../../Providers.StaticData/StaticDataProvider";

export class IdentityProviderData extends ODataSelect
{
    public Id = 0;
    public Name = '';
    public SecurityProviderTypeId: SecurityProviderId = SecurityProviderId_Native;
    public IsDefault = false;
}
